import React from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { loggingout } from "../../helpers/loggingOut";
import Logo from "../../assets/images/logo.webp";
import environment from "../../environment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const LogoutModal = ({ show }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  useEffect(() => {
    if (show) {
      localStorage.removeItem(environment.TOKEN_KEY);
      localStorage.removeItem(environment.REFRESH_TOKEN_KEY);
      localStorage.removeItem(environment.BACK_URL);
      setInterval(() => {
        navigate("/");
        window.location.reload();
      }, 10000);
    }
  }, [show]);

  return (
    <Modal show={show}>
      <Modal.Body>
        <Modal.Header></Modal.Header>
        <div className="modal-img">
          <img src={Logo} alt="logo" />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="60"
          height="60"
          viewBox="0 0 100.543 100.543"
          className="mb-3"
        >
          <g
            id="Iconly_Light_Danger-Circle"
            data-name="Iconly/Light/Danger-Circle"
            transform="translate(-0.25 -0.25)"
          >
            <g id="Danger-Circle" transform="translate(2.75 2.75)">
              <path
                id="Stroke-1"
                d="M48.522.75A47.771,47.771,0,1,1,.75,48.522,47.772,47.772,0,0,1,48.522.75Z"
                transform="translate(-0.75 -0.75)"
                fill="none"
                stroke="#90359c"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke-width="5"
                fill-rule="evenodd"
              />
              <line
                id="Stroke-3"
                y2="22.822"
                transform="translate(47.746 28.168)"
                fill="none"
                stroke="#90359c"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke-width="5"
              />
              <line
                id="Stroke-5"
                x2="0.052"
                transform="translate(47.745 67.376)"
                fill="none"
                stroke="#90359c"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke-width="5"
              />
            </g>
          </g>
        </svg>
        <div className="title">
          {Resource?.another_device_login
            ? Resource?.another_device_login
            : t("another_device_login")}
        </div>
        <div className="description">
          {Resource?.automatic_logout
            ? Resource?.automatic_logout
            : t("automatic_logout")}
          <br />
          {Resource?.press ? Resource?.press : t("press")}{" "}
          <span
            style={{
              cursor: "pointer",
              color: "var(--dark-purple)",
            }}
            onClick={() => {
              navigate("/");
              window.location.reload();
            }}
          >
            {Resource?.here ? Resource?.here : t("here")}{" "}
          </span>{" "}
          {Resource?.directly_logout
            ? Resource?.directly_logout
            : t("directly_logout")}{" "}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutModal;
